import { render, staticRenderFns } from "./AnimationNews.vue?vue&type=template&id=0be03de4&"
import script from "./AnimationNews.vue?vue&type=script&lang=js&"
export * from "./AnimationNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports